<script lang="ts">
  import type { WebColumnProps } from '$lib/types/layoutTypes';
  import PicturePanel from './PicturePanel.svelte';
  import RichTextPanel from './RichTextPanel.svelte';

  export let panel1: WebColumnProps['panel1'];
  export let panel2: WebColumnProps['panel2'];
</script>

<section class="lg:bg-gray-50 lg:py-24 lg:px-8">
  <div class="flex flex-col lg:flex-row lg:justify-center max-w-[1216px] mx-auto lg:gap-x-[120px]">
    <div
      class="basis-2/4 flex flex-col justify-center {panel1.contentType === 'RichTextPanel'
        ? 'items-start'
        : ''}"
    >
      <div class="pb-8 lg:pb-0 px-4 lg:px-0 flex flex-row justify-center lg:justify-start">
        {#if panel1.contentType === 'PicturePanel'}
          <div class="pb-4 lg:pb-0">
            <PicturePanel
              containerClass="py-0 flex flex-col gap-3"
              imgClass="object-contain rounded-xl w-full max-w-[374px] max-h-[374px] lg:max-w-none lg:max-h-[560px]"
              {...panel1}
            />
          </div>
        {/if}
        {#if panel1.contentType === 'RichTextPanel'}
          <div class="pb-8 lg:pb-0">
            <RichTextPanel {...panel1} />
          </div>
        {/if}
      </div>
    </div>

    <div
      class=" basis-2/4 flex flex-col justify-center {panel2.contentType === 'RichTextPanel'
        ? 'items-start'
        : ''}"
    >
      <div class="pb-8 lg:pb-0 px-4 lg:px-0 lg:px-0 flex flex-row justify-center lg:justify-end">
        {#if panel2.contentType === 'PicturePanel'}
          <div class="">
            <PicturePanel
              containerClass="py-0 flex flex-col gap-3"
              imgClass="object-contain rounded-xl w-full max-w-[374px] max-h-[374px] lg:max-w-none lg:max-h-[560px]"
              {...panel2}
            />
          </div>
        {/if}
        {#if panel2.contentType === 'RichTextPanel'}
          <div class="">
            <RichTextPanel {...panel2} />
          </div>
        {/if}
      </div>
    </div>
  </div>
</section>
